import { render } from "./VideoCallPage.vue?vue&type=template&id=252b25d2&scoped=true"
import script from "./videocallscript.js?vue&type=script&lang=js"
export * from "./videocallscript.js?vue&type=script&lang=js"

import "./VideoCallPage.vue?vue&type=style&index=0&id=252b25d2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-252b25d2"]])

export default __exports__